import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Download, Package } from "lucide-react";

export default function Orders() {
  const [data, setData] = useState({ bought: [], sold: [] });
  const [tab, setTab] = useState("bought");

  useEffect(() => { api.get("/orders/mine").then(r=>setData(r.data)).catch(()=>{}); }, []);

  const list = tab === "bought" ? data.bought : data.sold;
  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-8 py-10">
      <p className="overline mb-3">Marketplace orders</p>
      <h1 className="h-display text-4xl mb-6">Things you bought & sold.</h1>
      <div className="flex gap-2 mb-6" data-testid="orders-tabs">
        <button onClick={()=>setTab("bought")} className={`pill-link ${tab==="bought"?"active":""}`} data-testid="orders-tab-bought">Bought ({data.bought.length})</button>
        <button onClick={()=>setTab("sold")} className={`pill-link ${tab==="sold"?"active":""}`} data-testid="orders-tab-sold">Sold ({data.sold.length})</button>
      </div>
      <div className="space-y-3" data-testid="orders-list">
        {list.length === 0 ? (
          <p className="text-[#8A8A8A] text-center py-12">No orders here yet.</p>
        ) : list.map(o => (
          <div key={o.id} className="card p-5 flex items-center gap-4" data-testid={`order-row-${o.id}`}>
            <div className="h-14 w-14 rounded-xl bg-[#F2F2F0] flex-shrink-0 overflow-hidden">
              {o.product?.image && <img src={o.product.image} alt="" className="w-full h-full object-cover"/>}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{o.product_title}</p>
              <p className="text-xs text-[#8A8A8A]">{new Date(o.created_at).toLocaleString()}</p>
              <span className={`text-xs ${o.payment_status === "paid" ? "text-[#0A0A0A]" : "text-[#8A8A8A]"}`}>{o.payment_status}</span>
            </div>
            <div className="text-right">
              <p className="font-heading text-lg">${o.amount?.toFixed(2)}</p>
              {tab === "bought" && o.payment_status === "paid" && o.product?.file_url && (
                <a href={o.product.file_url} target="_blank" rel="noreferrer" className="btn-ghost text-xs" data-testid={`order-download-${o.id}`}><Download size={12}/> Download</a>
              )}
              {tab === "sold" && o.payment_status === "paid" && (
                <p className="text-xs text-[#4A4A4A]"><Package size={10} className="inline mr-1"/> +${o.provider_net?.toFixed(2)}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
